// 通用函数
import { nextTick} from 'vue';
import useClipboard from 'vue-clipboard3';
import { Message } from 'winbox-ui-next';
import { useRoleConfig } from '/@/stores/role';
import { useRoute, useRouter } from 'vue-router';
import { useChatStore } from '/@/stores/chat';
import { useSearchState } from '/@/stores/search';
// import { useI18n } from 'vue-i18n'
import { i18n } from '/@common/i18n';

const chatStore = useChatStore();
const roleConfig = useRoleConfig();
const searchStore = useSearchState();

export const copyText = function () {
	const { toClipboard } = useClipboard();
	// 点击复制文本
	const copyText = (text: string) => {
		return new Promise((resolve, reject) => {
			try {
				//复制
				toClipboard(text);
				//下面可以设置复制成功的提示框等操作
				Message.success(i18n.global.t('message.layout.copyTextSuccess'));
				resolve(text);
			} catch (e) {
				//复制失败
				Message.error(i18n.global.t('message.layout.copyTextError'));
				reject(e);
			}
		});
	};

	return {
		copyText,
	};
};
export const selectRole = async (item: any, type?: string) => {
	if (chatStore.dialogueLoading) {
		Message.warning({
			id: 'myInfo',
			content: i18n.global.t('chat.center.chatIng'),
			duration: 1000,
		});
		return;
	}
	chatStore.pluginFlag = false;
	// chatStore.pluginValue = true;
	chatStore.showCheck = false;
	await roleConfig.setCurrentRoleNew(item);
	if (item.code != 'ZHSSZJ') {
		chatStore.bgRoleName = item.roleName;
		chatStore.newBuilt(type);
	} else {
		roleConfig.currentRoleInformation = {
			fileTypes: [],
			plugins: [],
		};
		roleConfig.exampleQuestion = [];
	}
};
/**
 * 引用鼠标点击事件
 * @param id 对话dialogue Id
 * @param no no
 * @param index 出现位置
 * @param chatIndex 对话索引
 */
export async function ragTagSearchClick(id: any, no: any, index: any, chatIndex: any) {
	if (!id) {
		return
	}
	const sourceDataId = `doc-${id}-${no}`;
	const domId = `doc-${id}-${no}-${index}`;
	chatStore.chatList[chatIndex].isRightBox = true;
	searchStore.activeCitations = domId;
	await nextTick();
	// const ragItems = document.querySelectorAll('.ragItem');
	const citationsItems = document.querySelectorAll('.search-citations');
	// if (ragItems) {
	// 	ragItems.forEach(item => {
	// 		item.classList.remove('highlight');
	// 	});
	// }
	if (citationsItems) {
		citationsItems.forEach((item) => {
			item.classList.remove('citations-highlight');
			item.classList.remove('citations-highlight-nodata');
		});
	}
	const getSourceDom = document.getElementById(''.concat(sourceDataId));
	const getItemeDom = document.getElementById(''.concat(domId));

	if (getSourceDom) {
		getSourceDom.scrollIntoView({
			behavior: 'smooth',
			block: 'nearest',
			inline: 'nearest',
		});
		if (!getItemeDom?.innerText) {
			return;
		}
		if (getItemeDom) {
			getSourceDom.classList.add('citations-highlight');
		} else {
			getSourceDom.classList.add('citations-highlight-nodata');
		}

		getSourceDom.classList.add('highlight');
	}
}
